import React from "react";

import { useNullableDealerAccountInfo } from "../../../../../stores/hooks/useNullableDealerAccountInfo";
import { isMbApproved } from "../../../../../util/isMbApproved";
import { isStarApproved } from "../../../../../util/isStarApproved";
import { ModifiedTirePartItem } from "../../useTireResults";
import { Best } from "./Best";
import { Better } from "./Better";
import { Good } from "./Good";
import { MbApproved } from "./MbApproved";
import { OETire } from "./OETire";
import { StarApproved } from "./StarApproved";

type RibbonProps = {
  className?: string;
  index: number;
  part: ModifiedTirePartItem | null;
};

export const useRibbon = ({
  className,
  index,
  part,
}: RibbonProps): JSX.Element | null => {
  const dealer = useNullableDealerAccountInfo();

  const isOriginalEquipment =
    part?.partDetails.primaryPart.tireOriginalEquipmentFlag ?? false;

  if (
    isOriginalEquipment &&
    isMbApproved(dealer?.dealerNationalAccountId ?? "")
  ) {
    return <MbApproved className={className} />;
  }

  if (
    isOriginalEquipment &&
    isStarApproved(dealer?.dealerNationalAccountId ?? "")
  ) {
    return <StarApproved className={className} />;
  }

  if (part?.featured) {
    const Component = { 1: Better, 2: Best }[index] || Good;
    return <Component className={className} />;
  }

  if (isOriginalEquipment) {
    return <OETire className={className} />;
  }

  return null;
};
